var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-card',[_c('v-card-title',[_c('span',[_vm._v("You are not authorized to access that page.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }